/**
 * The countries the funnel supports. This is deliberately not part of `Config`:
 * MAHLE serves Germany and Austria from a single organization, so the country is
 * a runtime property of the searched location, not of the whitelabel.
 */
export type SupportedCountry = "DE" | "AT";

/**
 * HERE returns ISO 3166-1 alpha-3 codes ("DEU", "AUT") in `address.countryCode`,
 * not the alpha-2 codes used everywhere else in the app.
 *
 * Anything unknown or missing maps to "DE" on purpose: flows that mount without a
 * selected place (partner, fleet) must keep behaving exactly as they do today.
 */
export function fromHereCountryCode(code?: string | null): SupportedCountry {
  return code?.toUpperCase() === "AUT" ? "AT" : "DE";
}
